'use strict';

var React = require('react');
var Border = require('../common/Border');
var assetsHelper = require('../../helper/assetsHelper');
var styleHelper = require('../../helper/styleHelper');
var appTypes = require('../../types/appTypes');

/**
 * 时间选择器
 */
var DateTimePicker = React.createClass({

  render: function () {
    var borderStyle;
    var containerStyle;
    var imgStyle;
    var imgDivStyle;
    var imgWidth;
    var textStyle;
    var w = styleHelper.getWidth(this.props);
    var h = styleHelper.getHeight(this.props);

    containerStyle = {
      width: '100%',
      height: '100%'
    };

    imgWidth = Math.min(h, 64);

    imgDivStyle = {
      backgroundColor:'#fff',
      width: imgWidth,
      height: imgWidth,
      right: 0,
      top: (h - imgWidth)/2,
      position: 'absolute',
      boxSizing:'border-box'
    };

    imgStyle = {
      top: 0,
      left: 0,
      width: imgWidth ,
      height: imgWidth ,
      position: 'absolute'
    };

    borderStyle = {
      width: w - imgWidth - 1,
      height:'100%',
      position: 'absolute',
      whiteSpace : 'nowrap',
      boxSizing : 'border-box',
      overflow:'hidden'
    };
    styleHelper.StyleUtil(this.props,borderStyle).text().background().border();

    textStyle = {
      top: 0,
      left: borderStyle.fontSize/4,
      height : h,
      position:'absolute',
      width:borderStyle.width - borderStyle.fontSize/2,
      //wordSpacing : -1,
      lineHeight : h + 'px',
      overflow:'hidden'
    };

    return (<div style={containerStyle}>
      <div style={borderStyle}>
        <label
          style={textStyle}
        >{styleHelper.getText(this.props)}</label>
      </div>
      <div style={imgDivStyle}>
        <img style={imgStyle}
             src={assetsHelper.getComponentAsset('Calendar_')}/>
      </div>
    </div>);
  }

});

module.exports = DateTimePicker;



/** WEBPACK FOOTER **
 ** ./src/views/Components/DateTimePicker.jsx
 **/